<template>
  <div
    class="pay-container"
    v-if="skuDetail.productName"
  >
    <div class="pay-info-content">
      <div
        class="heard-phone"
        v-show="!buyProcessShow"
      >
        <account
          :placeholder="placeHolder"
          :account-type="skuDetail.accountType"
          :phone-input-disabled="phoneInputDisabled"
          @getAccount="getAccount"
        />
      </div>
      <div
        class="product-content process-container"
        v-if="buyProcessShow"
      >
        <h2 class="process-title">
          简单2步 优惠购买
        </h2>
        <i class="process-img"></i>
      </div>
      <div :class="['product-content', {no: isShowProductDetails && skuDetail.productDetail}]">
        <div class="product-info-content">
          <div class="logo-content">
            <img
              class="logo"
              v-lazy="productPic"
            />
          </div>
          <div class="detail">
            <p class="info">
              <span class="name">{{ skuDetail.productName }}{{ skuDetail.skuName }}</span>
              <span class="price">￥{{ ((isFzsPlus === false && plusSalePrice) || skuDetail.sellingPrice) | number }}</span>
            </p>
            <p class="tip">
              <i class="icon"></i>
              <span class="txt">充值商品不支持退换货</span>
            </p>
          </div>
        </div>
        <div 
          class="jump-detail" 
          v-if="isShowProductDetails && skuDetail.productDetail" 
          @click="jumpDetail"
        >
          商品说明，教您如何使用
          <span class="icon"></span>
        </div>
      </div>
      <div
        class="coupon-content"
        v-if="isCoupon==='true'"
        @click="togglePrompt"
      >
        <div class="coupon-tip-box">
          <span class="txt">优惠券</span>
          <span
            class="coupon-text"
            v-show="couponList.usableList.length"
          >已选择推荐优惠券</span>
        </div>
        <div class="flex">
          <span class="content-text coupon">{{ couponTipText }}</span>
          <i class="icon"></i>
        </div>
      </div>
      <pay-method
        :types="'one'"
        v-if="payMethodList.length"
        :selling-price="(priceInfo.sum+'')"
      />
      <div
        class="plus-img"
        v-if="plusImg && isFzsPlus === false"
      >
        <img
          @click="linkPlus"
          :src="plusImg"
          alt="/"
        >
      </div>
      <div 
        class="fix-content" 
        :class="{buyProcessShow: buyProcessShow}"
      >
        <p class="price">
          <span class="txt">总金额:</span>
          <span class="num">￥{{ ((isFzsPlus === false && plusSalePrice) || priceInfo.sum) | number }}</span>
        </p>
        <v-button
          :need-buy-plus="isFzsPlus === false"
          :button-style="payBtnStyle"
          @login="login"
          @click="pay"
        >
          {{ isFzsPlus === false ? '开通会员立即购买' : '立即购买' }}
        </v-button>
      </div>
    </div>

    <!-- 优惠券信息-->
    <coupon
      v-if="showPrompt"
      @close="togglePrompt"
    />
    <!--支付失败提示-->
    <pay-error
      :pay-error="payError"
      @close="closeError"
    />
    <!--微信弹窗-->
    <wx-modal
      v-if="wechatPay.showModal"
      :wx-pay-info="wechatPay"
    ></wx-modal>
    <!--登录弹窗-->
    <login-box
      :login="loginBox"
      @loginState="loginState"
      @cancel="cancelLogin"
    />

    <prompt
      :show-prompt="showCbcPay"
    >
      <CBCPayDialog
        @on-close="toggleShowCbc"
        :card-info="cardInfo"
        :sum="priceInfo.sum"
        :code="code"
        :clear-sms-time="clearCBCSmsTime"
        @on-send="getCBCSmsCode"
        @on-submit="submit"
      />
      <number-keyboard
        :show="showKeyboard"
        close-button-text="完成"
        @input="keyInput"
        @delete="keyDelete"
        @close="keyboardBlur"
      />
    </prompt>
    <!-- 调试按钮 -->
    <button 
      :style="{width:'200px',heigth:'200px', marginTop: '20px', opacity: 0}" 
      @click="showLog"
    >
      调试按钮
    </button>
    <Confirm
      :is-show="confirmShow"
      :call-back="confirmCallBack"
      @onClose="() => confirmShow=false"
    />
    <!-- 引导开通宝藏卡 -->
    <div
      class="prompt-container"
      v-if="showStorehouseCard"
      @touchmove.prevent
    >
      <div class="prompt" />
      <div class="open-storehouse-card">
        <div class="header-close-box">
          <i
            class="icon"
            @click="showStorehouseCard=false"
          />
        </div>
        <p class="desc">
          所登录的手机号非指定宝藏卡号码
        </p>
        <div class="btn-row">
          <button class="tip">
            限时0月租
          </button>
          <button 
            class="btn" 
            @click="goOpenStorehouseCard"
          >
            马上获取指定宝藏卡号码
          </button>
        </div>
      </div>
    </div>
    <!-- 提示安装农行APP -->
    <div
      class="prompt-container"
      v-if="showTipAppInstalled"
      @touchmove.prevent
    >
      <div class="prompt" />
      <div class="tip-app-installed">
        <div class="header-close-box">
          <i
            class="icon"
            @click="showTipAppInstalled=false"
          />
        </div>
        <p class="ttl">
          温馨提示
        </p>
        <p class="desc">
          你没有安装中国农业银行APP，无法使用农业银行支付，请去应用市场下载安装中国农业银行APP。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'
  import {Api} from '../api/'
  import config from '../config/'
  import {clientService} from '../services/clientService'
  import {getCacheUserInfo, setStorageCache, isIOS, getSessionCache, setSessionCache, clearUserInfo, getUrlHash, isObject} from '../utils'
  import {PayHelpers} from '../utils/payHelper'
  import LoginBox from '../components/login'
  import {NumberKeyboard} from 'vant'

  import payMethod from '../components/payMethod'
  import Coupon from '../components/Coupon'
  import VButton from '../components/Button'
  import payError from '../components/payError'
  import Account from '../components/Account/index'
  import wxModal from '../components/WeChatModal'
  import Confirm from '../components/Confirm'
  import CBCPayDialog from '../components/CBCPayDialog'
  import {getFzsPlus, buyBeforePoint, jumpHomeBeforePoint, detailLoadComplete, errorReport} from "../services";
  import {getPayfulLife} from '../utils/partyThirdSdk'

  import VConsole from 'vconsole'
  export default {
    name: 'pay',
    computed: {
      ...mapGetters({
        user: 'user' // 用户信息
        , client: 'client' // 客户端信息
        , skuDetail: 'skuDetail'
        , payMethodList: 'payMethodList' //  支付方式
        , paymentSubCode: 'paymentSubCode' //  支付方式
        , paySelectedIndex: 'paySelectedIndex' //  支付方式
        , couponList: 'couponList' // 优惠券列表
        , couponInfo: 'selectedCoupon' // 使用优惠券信息
        , priceInfo: 'priceInfo'
      })
      , ...mapState({
        payEnv: state => state.product.payEnv // App应用环境
      })
      // 选优惠券后文字显示
      , couponTipText() {
        let tipText = '请选择'
        switch (this.couponInfo.couponMode) {
          case 'Cash':
            tipText = '-' + (this.couponInfo.discountFee || this.couponInfo.amountMax) + '元'
            break
          case 'Discount':
            tipText = this.couponInfo.amountMax + '折'
            break
          case 'Random':
            tipText = '随机减'
            break
        }
        return tipText
      }
      // 商品图片
      , productPic() {
        let {productPic} = this.skuDetail
        return productPic ? (productPic.includes('http') ? productPic : `${this.imgRoot}${productPic}`) : ''
      }
      , placeHolder() {
        return this.skuDetail.accountHint ? this.skuDetail.accountHint : '请输入充值账号'
      }
      , phoneInputDisabled () {
        if (config.phoneInputDisabled) {
          return !(this.skuDetail.couponproduct && this.skuDetail.couponproduct === 'true')
        } else {
          return config.phoneInputDisabled
        }
      }
    },
    data() {
      return {
        imgRoot: ''
        , productId: ''
        , skuId: ''
        , showPrompt: false  // 显示或隐藏优惠券
        , account: '' // 充值账号
        , payError: {
          show: false
          , msg: ''
        }
        // 自有微信支付轮询信息
        , wechatPay: {
          payUrl: '',
          orderId: '',
          toggleWxApp: true,
          showModal: false
        }
        , loginBox: {
          type: '', // coupon
          show: false // 显示提示登录
        }
        , cardInfo: {} // 银行卡信息
        , showKeyboard: true,
        showCbcPay: false, // 展示建行弹窗
        code: '',
        isCoupon: config.isCoupon,
        clearCBCSmsTime: false,
        cBCSmsErrorMessage: '',
        submitActive: false,
        payBtnStyle: config.template.BotBgStyle,
        plusImg: config.template.PlusAD,
        plusSalePrice: null, // 当前商品的plus会员价钱
        isFzsPlus: null, // 当前用户是否是会员
        buyProcessShow: config.buyProcessShow,
        confirmShow: false, // 确认弹窗展示方法
        isShowProductDetails: config.isShowProductDetails, // 展示商品详情
        confirmCallBack: () => {}, // 确认弹窗回调方法
        isWhite: false, // 校验白名单
        actionNo: '',
        showStorehouseCard: false, // 展示开通宝藏卡弹窗
        showTipAppInstalled: false // 展示提示安装农行APP
      }
    },
    mounted() {
      this.productId = this.$route.params.productId
      this.skuId = this.$route.params.skuId
      this.uuid = window.localStorage.getItem('uuid')
      if (!this.productId && !this.skuId) {
        this.$router.push('/')
      }
      // 业务链接传递活动方案编号
      let schemeNo = this.$route.params.schemeNo || getSessionCache('schemeNo')
      if (schemeNo) {
        config.schemeNo = schemeNo
        setSessionCache('schemeNo', schemeNo)
      }
      this.isWhite = getUrlHash('isWhite')?getUrlHash('isWhite')==='true': false
      if(this.isWhite){
        this.actionNo = getUrlHash('actionNo')?getUrlHash('actionNo'):''
      }
      this.imgRoot = Api.imgRoot
      // 获取用户信息
      this.$store.dispatch('getEnv').then(() => {
        this.$store.dispatch('appInfoInitialize')
          .then(() => {
            setTimeout(() => {
              this.updateUserInfo()
            }, 200)
            // 需要登录后调用，这里采用延迟400是因为比较难控制updateUserInfo的先执行
            setTimeout(() => {
              config.isSetTracking && detailLoadComplete({ 
                userId: this.user.userID, 
                productId: this.productId, 
                clientId: this.client.clientVersionId,
                channelId: this.client.channelId,
              })
            },400)
          })
      })
      if (isIOS() && this.client.env != 'app') { // 只有在微信H5上才有，为了给H5微信支付跳转后界面刷新使用后还能轮训支付结果
        let wxPayInfo = getSessionCache('wxPayInfo')
        let wxPayInfoTime = getSessionCache('wxPayInfoTime')
        let time = new Date().getTime()
        if (wxPayInfo && wxPayInfoTime && (time - wxPayInfoTime) < 120000) {
          this.wechatPay = Object.assign({}, wxPayInfo, {
            toggleWxApp: false
          })
        }
      }
    },
    methods: {
      showLog() {
        // let vConsole = require('vconsole')
        
        new VConsole()
        
      },
      // 跳转plus会员
      linkPlus() {
        if (!this.user.token) {
          this.login()
          return
        }
        let {PlusAdLink, PlusAdLinkH5, PlusAdLinkIos} = config.template
        if (this.client.env === 'app') { // 当前是app环境
          if ((PlusAdLinkIos && isIOS()) || (PlusAdLink && !isIOS())) {
            import('../services/clientService').then(res => {
              const {clientService} = res
              clientService.jumpApp(config.versionName, isIOS() ? JSON.parse(PlusAdLinkIos) : JSON.parse(PlusAdLink))
            })
          } else if (PlusAdLinkH5) {
            window.location.href = PlusAdLinkH5
          }
        } else if (PlusAdLinkH5) {
          window.location.href = PlusAdLinkH5
        }
      },
      updateUserInfo() {
        let cacheUser = getCacheUserInfo()
        if (!this.phoneInputDisabled && !cacheUser.token) {
          this.login()
        }
        if (cacheUser) {
          this.$store.dispatch('updateUserInfo', {data: cacheUser})
          this.fetchProductDetail()
        }
        this.loopGetSycnUserInfo()
        if (config.template && config.template.PlusBuy === 'true') {
          this.$store.dispatch('getSkuList').then(res => {
            if (res.datas.length > 0 && res.datas[0].skuList && res.datas[0].skuList.length > 0) {
              let item = res.datas[0].skuList.filter(item => item.skuId === this.skuId)
              this.plusSalePrice = item && item[0].salePrice
            }
          })
          if (!cacheUser) {
            this.isFzsPlus = false
          } else {
            this.getPlus()
          }
        }
      },
      getPlus() {
        if (!this.user.token) {
          clearUserInfo()
          this.$store.dispatch('updateUserInfo', {data: {token: ''}})
          this.isFzsPlus = false
          return
        }
        getFzsPlus({
          authToken: this.user.token
        }).then(({data}) => {
          let res = data
          if (res.message === 'SESSION_EXPIRES') {
            clearUserInfo()
            this.$store.dispatch('updateUserInfo', {data: {token: ''}})
          }
          this.isFzsPlus = res.success && res.datas &&res.datas.state === '1'
        }).catch(() => {this.isFzsPlus = false})
      }
      // 请求商品详情
      , fetchProductDetail() {
        this.$spinner.open('正在加载中...')
        this.$store.dispatch('fetchProductDetail', {
          productId: this.productId
          , skuId: this.skuId
        })
          .then(() => {
            this.$analysis.trackEvent('【商品详情页】', 'product_details_uv', `${this.skuDetail.productName}${this.skuDetail.skuName}`)
            // 深圳新卡配置信息
            if (this.skuDetail.packageInfo) {
              setStorageCache('packageInfo', JSON.parse(this.skuDetail.packageInfo))
            } else {
              window.localStorage.removeItem('packageInfo')
            }
          })
          .catch(() => {
            this.jumpError()
          })
          .finally(() => {
            this.$spinner.close()
          })
      }
      , jumpError() {
        this.$router.push({name: 'servererror'})
      }
      // 显示或隐藏优惠券
      , togglePrompt() {
        this.showPrompt = !this.showPrompt
      }
      , toggleShowCbc(val = false) {
        this.showCbcPay = val
        if (!val) {
          setTimeout(() => {
            this.code = ''
          }, 2000)
        }
      },
      // 发短信 钱包支付
      getCBCSmsCode() {
        this.setClearCBCSmsTime({
          state: false,
          msg: ''
        })
        this.$store.dispatch('sendCbcPaySmsCode')
          .then((data) => {
            if (data.success && data.errorCode === "0000") {
              this.$toast('已下发短信，请注意查收')
            } else {
              this.setClearCBCSmsTime({
                state: true,
                msg: data.msg || data.errorMessage || '请重新获取短信验证码'
              })
              this.$toast(data.msg || data.errorMessage || '发送失败')
            }
          })
          .catch(() => {
            this.setClearCBCSmsTime({
              state: true,
              msg: '请重新获取短信验证码'
            })
            this.$toast('发送失败')
          })
      },
      setClearCBCSmsTime({state, msg}) {
        this.clearCBCSmsTime = state
        this.cBCSmsErrorMessage = msg
      },
      // 钱包支付短信验证
      keyInput(value) {
        this.code += value
        if (this.code.length > 6) {
          this.code = this.code.slice(0, 6)
        }
      },
      // 钱包支付删除短信
      keyDelete() {
        if (this.code) {
          this.code = this.code.slice(0, -1)
        }
      },
      // 钱包支付实物焦点
      keyboardBlur() {
        if (!this.code || this.code.length < 6) return
        this.toggleShowCbc()
        this.submit()
      },
      // 匹配客户端id，当配置isMatchClient时，查银行卡号需进行客户端id校验
      isMatchClient(clientId) {
        if (!config.needMatchClient) return true
        return this.client.clientVersionId === clientId
      }
      // 下单
      , pay() {
        if (!this.user.token) {
          this.login()
          return
        }
        if (!this.account) {
          this.$toast('请输入正确的充值号码')
          return
        }
        const sub = () =>{
          // 埋点
          config.isSetTracking && buyBeforePoint({
            clientId: this.client.clientVersionId,
            channelId: this.client.channelId,
            userId: this.user.userID, 
            productId: this.productId,
            guid: this.uuid
          })
          if (((this.paymentSubCode === 'CBCPAY_WALLET' || this.paymentSubCode === 'ABC_WALLET' || this.paymentSubCode === 'CITIC_WALLET_PAY' || this.paymentSubCode === 'SPDB_WALLET_PAY')  && !this.code) || (this.payMethodList[this.paySelectedIndex].paymentMethodId === 'FZS_WALLET')) {
            this.$store.dispatch('getBankCard')
              .then((data) => {
                this.$spinner.close()
                if (data === 'h5loginExpired') {
                  this.login()
                  return
                }
                if (data.success) {
                  if (data.datas && data.datas.length > 0) {
                    // 处理客户端号码匹配
                    const { clientId } =  data.datas[0]
                    if (!this.isMatchClient(clientId)) {
                      this.payError.show = true
                      this.payError.msg = '禁止下单'
                      return 
                    }
                    let tip = false
                    for (let i = 0; i < data.datas.length; i++) {
                      if ((this.paymentSubCode === 'CBCPAY_WALLET' || this.paymentSubCode === 'FZS_WALLET_CCB') && data.datas[i].state === 'ACTIVATED' && data.datas[i].mediumBank === 'CCB') {
                        this.cardInfo = data.datas[i]
                        tip = true
                        break
                      }
                      if ((this.paymentSubCode === 'ABC_WALLET' || this.paymentSubCode === 'FZS_WALLET_ABC') && data.datas[i].state === 'ACTIVATED' && data.datas[i].mediumBank === 'ABC') {
                        this.cardInfo = data.datas[i]
                        tip = true
                        break
                      }
                      if ((this.paymentSubCode === 'CITIC_WALLET_PAY' || this.paymentSubCode === 'FZS_WALLET_CITIC') && data.datas[i].state === 'ACTIVATED' && data.datas[i].mediumBank === 'CITIC') {
                        this.cardInfo = data.datas[i]
                        tip = true
                        break
                      }
                      if ((this.paymentSubCode === 'SPDB_WALLET_PAY' || this.paymentSubCode === 'FZS_WALLET_SPDB') && data.datas[i].state === 'ACTIVATED' && (data.datas[i].mediumBank === 'SPDB' || data.datas[i].mediumBank === 'SPDBANK')) {
                        this.cardInfo = data.datas[i]
                        tip = true
                        break
                      }
                    }
                    if (tip) {
                      if(this.payMethodList[this.paySelectedIndex].paymentMethodId === 'FZS_WALLET') { // 新钱包支付
                        this.submit()
                      } else {
                        this.toggleShowCbc(true)
                      }
                    } else {
                      config.isSetTracking && jumpHomeBeforePoint({
                        clientId: this.client.clientVersionId,
                        channelId: this.client.channelId,
                        userId: this.user.userID, 
                        productId: this.productId
                      })
                      this.$store.dispatch('goBindBackCard')
                    }
                  } else {
                    config.isSetTracking && jumpHomeBeforePoint({
                      clientId: this.client.clientVersionId,
                      userId: this.user.userID, 
                      productId: this.productId
                    })
                    this.$store.dispatch('goBindBackCard')
                  }
                } else {
                  if (data.errorCode === '410014') { // 银行卡不存在
                    config.isSetTracking && jumpHomeBeforePoint({
                      clientId: this.client.clientVersionId,
                      channelId: this.client.channelId,
                      userId: this.user.userID, 
                      productId: this.productId
                    })
                    this.$store.dispatch('goBindBackCard')
                  } else {
                    config.isSetTracking && errorReport ({ 
                      clientId: this.client.clientVersionId, 
                      channelId: this.client.channelId,
                      guid: this.uuid, 
                      errorInfo: JSON.stringify({ user: this.user, error: data}) 
                    })
                    this.$toast('服务器异常，请稍后重试')
                  }
                }
              })
              .catch((e) => {
                console.log(e)
                this.$spinner.close();
                config.isSetTracking && errorReport ({ 
                  clientId: this.client.clientVersionId, 
                  channelId: this.client.channelId, 
                  guid: this.uuid, 
                  errorInfo: JSON.stringify({ user: this.user, error: e }) 
                });
                this.$toast('服务器异常，请稍后重试')
              })
            return
          }
          this.submit()
        } 
        const checkWhite = () => {
          // this.$spinner.open('加载中...');
          // 需要判断是不是白名单
          if (this.isWhite) {
            this.$store.dispatch('collectUserAction', {
              actionNo: this.actionNo
            })
            .then(()=> {
              sub()
            })
            .catch((data)=>{
              if(data.errorCode === "450001"){ // 不在白名单
                  this.$spinner.close()
                  this.showStorehouseCard = true
                } else {
                  sub()
                }
            })
          } else {
            sub()
          }
        }
        // fzsAPP需要判断有没有安装农行
        if(this.client.env === 'app' && this.paymentSubCode === 'ABCPAY_SDK'){
          clientService.chenkAppIsInstalled(config.versionName, !isIOS() ? {
            packageName: "com.android.bankabc",
          } : {
            iosApp: 'abc'
          }, data => {
            if(data && isObject(data)){
              if((!isIOS() && data.isInstalled) || (isIOS() && data.isInstalled==='true')){
                checkWhite()
              } else {
                this.showTipAppInstalled = true
              }
            } else { // 旧版本没有这个方法
              checkWhite()
            }
          })
        } else {
          checkWhite()
        }
      }
      , submit() {
        if ((this.paymentSubCode === 'CBCPAY_WALLET' || this.paymentSubCode === 'ABC_WALLET' || this.paymentSubCode === 'CITIC_WALLET_PAY' || this.paymentSubCode === 'SPDB_WALLET_PAY') && this.clearCBCSmsTime) { // 没有发送成功短信
          this.$toast(this.cBCSmsErrorMessage)
          return
        }
        if (this.submitActive) {
          return
        }
        this.submitActive = true
        this.toggleShowCbc(false)
        this.$store.dispatch('clearOrderInfo')
        this.$analysis.trackEvent('【立即购买】', 'order_submit_click', `${this.skuDetail.productName}${this.skuDetail.skuName}`)
        this.$spinner.open('正在提交...')
        this.$store.dispatch('submit', {
          account: this.account,
          code: this.code
        })
          .then(data => {
            this.$spinner.close()
            let {datas} = data
            if (!datas.login) {
              this.submitActive = false
              clearUserInfo()
              this.$store.dispatch('updateUserInfo', {data: {token: ''}})
              this.login()
              return
            }
            if (this.paymentSubCode === 'SPDB_WALLET_PAY') {
              setSessionCache('SPDBCARDINFO', this.cardInfo.successFulLink)
            }
            let {orderItems, ext} = datas
            // 存储一个临时账号，为了给H5微信支付跳转后界面刷新使用
            if (isIOS() && this.client.env != 'app') { // 只有在微信H5上才有
              setSessionCache('cacheAccountTemporary', this.account)
            }
            setStorageCache('productInfo', Object.assign({}, datas, orderItems[0], ext, {
              createTime: datas.orderCreateTime,
              salePrice: datas.saleAmount,
              dealPrice: datas.payAmount,
              proPrice: datas.saleAmount,
              target: datas.orderTarget,
              picUrls: this.productPic,
              extValue: '',
              contactName: '',
              contactPhone: '',
              contactAddress: ''
            }))
            setTimeout(() => {
              this.submitActive = false
            }, 5000)
            if (data.datas.payStr === 'useless') { // 0元支付
              this.$router.push({name: 'result', params: {state: 'complete'}})
              return false
            }
            // 钱包支付
            if (this.paymentSubCode === 'CBCPAY_WALLET' || this.paymentSubCode === 'ABC_WALLET' || this.paymentSubCode === 'CITIC_WALLET_PAY' || this.paymentSubCode === 'SPDB_WALLET_PAY') {
              this.wechatPay = Object.assign(this.wechatPay, {
                showModal: true,
                isWalletPay: true,
                orderId: data.datas.orderId
              })
              return false
            }
            if(this.paymentSubCode === 'DIGITAL_RMB_H5_GATEWAY'){
              window.location.href = data.datas.payStr
              return
            }
            // // 中信全付通
            // if(this.paymentSubCode === 'CITIC_UNIVERSALPAY_QFT_H5'){
            //   window.location.href = `${data.datas.payStr}&front_url=${config.indexUrl}`
            //   return
            // }
            // 华为支付
            if (this.paymentSubCode === 'HUAWEIPAY') {
              let payStr = JSON.parse(data.datas.payStr)
              let params = {
                PartnerID: payStr.partnerId || payStr.PartnerID,
                TN: payStr.tn || payStr.TN,
                SignData: payStr.signData || payStr.SignData
              }
              params = JSON.stringify(params)
              params = window.encodeURIComponent(params)
              this.wechatPay = Object.assign(this.wechatPay, {
                showModal: true,
                isWalletPay: true,
                orderId: data.datas.orderId
              })
              window.location.href = `financeclient://com.huawei.wallet/thirdpayservice?action=thirdpayservice&params=${params}`
              return
            }
            // 华融湘江
            if (this.payMethodList[this.paySelectedIndex].paymentMethodId === 'JH_UNIVERSALPAY') {
              const newPayStr = JSON.parse(data.datas.payStr)
              if (isIOS()) {
                window.webkit.messageHandlers.payment.postMessage([newPayStr.ordrNo, newPayStr.mrchSndDt])
              } else {
                window.Payment.payment(newPayStr.ordrNo, newPayStr.mrchSndDt)
              }
              return
            }
            if(this.payMethodList[this.paySelectedIndex].paymentMethodId === 'CZY_PAY'){
              getPayfulLife(data.datas.payStr, window.location.origin + window.location.pathname + '#/result?state=success')
              return
            }
            // 钱包支付新
            if (this.payMethodList[this.paySelectedIndex].paymentMethodId === 'FZS_WALLET') {
              this.$store.dispatch('goFzsWalletPay', {
                payStr: data.datas.payStr, 
                bankName: this.cardInfo.bankName,
                bankNo: this.cardInfo.cardNo,
                mobile: this.cardInfo.mobile
              })
              // window.location.href = `${data.datas.payStr}&authToken=${this.user.token}`
              return
            }
            if (this.client.env === 'wxMini') {
              this.$store.dispatch('wxMiniPay', datas)
            } else {
              PayHelpers[this.payEnv](data, this)
            }
          })
          .catch((e) => {
            this.submitActive = false
            if (e.errorCode === '506') {
              this.payError.show = true
              this.payError.msg = '该手机号码暂不支持办理本业务'
            } else if (e.errorCode === '5107') {
              this.payError.show = true
              this.payError.msg = '抱歉，商品已售罄' // '抱歉，你暂无资格购买'
            } else if (['5097', '5112'].includes(e.errorCode)) {
              this.payError.show = true
              this.payError.msg = this.isWhite? '您已经享受完优惠，谢谢支持': '抱歉，已超出活动优惠购买次数'
            } else if (e.errorCode === '600') { // 登陆失效
              clearUserInfo()
              this.$store.dispatch('updateUserInfo', {data: {token: ''}})
              this.login()
            } else if(e.errorCode === '505' && this.payMethodList[this.paySelectedIndex].paymentMethodId === 'FZS_WALLET'){
              if (e.errorMessage.indexOf('authToken')>-1) {
                clearUserInfo()
                this.$store.dispatch('updateUserInfo', {data: {token: ''}})
                this.login()
              } else {
                this.payError.show = true
                this.payError.msg = '订单提交失败，请稍后重试'
              }
            } else {
              this.payError.show = true
              this.payError.msg = '订单提交失败，请稍后重试'
            }
            this.$spinner.close()
          })
      }

      , getAccount(account) {
        this.account = account
      }
      // 关闭下单错误提示
      , closeError() {
        this.payError.show = false
      }
      // 登录
      , login() {
        // fix（2020-10-12）:如果支付页面登录失效，用了别人没有优惠资格的人去下单，会导致无优惠资格但是展示优惠资格，所以这里修复为返回首页让用户去重新登录
        const backIndexUrl = getSessionCache('backIndexUrl')
        if (backIndexUrl) {
          window.location.replace(backIndexUrl)
          return
        } 

        let {env} = this.client
        if (env === 'app') { // FZSapp
          /* eslint-disable no-undef */
          clientService.jumpToLogin({}, (data) => {
            if (data && data.isLogin) {
              window.location.reload()
            }
          })
        } else if (env === 'wxMini') { // 微信小程序
          this.$store.dispatch('wxMiniOverdue')
        } else if (env === 'wx' && config.wxUrl) { // 微信端登录
          this.$store.dispatch('authentication')
        } else { // H5
          // 普通H5弹窗登录
          this.loginBox.show = true
        }
      }
      , loginState() {
        this.updateUserInfo()
        this.loginBox.show = false
      }
      // 刷新FZStoken
      , getSycnUserInfo(){
        let {token} = this.user
        if (!token) {
          return
        }
        this.$store.dispatch('getSycnUserInfo', {
          authToken: token
        }).then(()=>{
          this.loopGetSycnUserInfo()
        })
        .catch(()=>{
          this.login()
        })
      }
      // 轮训刷新token
      , loopGetSycnUserInfo(){
        setTimeout(()=> {
          this.getSycnUserInfo()
        }, 1800000)
      }
      , cancelLogin() {
        this.loginBox.show = false
      }
      // 跳转商品说明
      ,jumpDetail(){
        setSessionCache('productDetail', this.skuDetail.productDetail)
        this.$router.push({name: 'productDetail'})
      },
      // 跳转开通宝藏卡
      goOpenStorehouseCard(){
        window.location.href = config.storehouseCardUrl
      }
    },
    components: {
      Account
      , VButton
      , Coupon
      , payMethod
      , payError
      , wxModal
      , LoginBox
      , CBCPayDialog
      , NumberKeyboard
      , Confirm
    }
    ,
    destroyed() {
      this.$store.dispatch('resetSkuDetail')
    }
  }
</script>
<style scoped lang="scss">
  @import "../assets/common.scss";
  .pay-container {
    @extend %container;
    padding-bottom: 300px;
    padding-bottom: calc(300px + constant(safe-area-inset-bottom));
    padding-bottom: calc(300px + env(safe-area-inset-bottom));

    .pay-info-content {
      .heard-phone {
        @extend %content;
      }

      .product-content {
        @extend %content;
        padding: 50px 35px 0 43px;
        /*position: relative;*/
        .logo-content {
          /*position: absolute;*/
          width: 215px;
          flex: 0 0 auto;
          margin-right: 21px;
          @extend %flex-center-center;

          .logo {
            width: 170px;
          }
        }

        .detail {
          /*width: 100%;*/
          width: calc(100% - 215px);
          width: -webkit-calc(100% - 215px);
          width: -moz-calc(100% - 215px);
          /*padding-left: 215px;*/
          .info {
            font-size: 36px;
            @extend %flex-between-center;

            .name {
              color: #000000;
              line-height: 48px;
            }

            .price {
              color: #ff0000;
              flex: 0 0 auto;
              padding-left: 100px;
            }
          }

          .tip {
            font-size: 30px;
            color: #fe6c00;
            margin-top: 55px;

            .icon {
              width: 29px;
              height: 31px;
              display: inline-block;
              background: url("../assets/image/icon-tip.png") no-repeat;
              background-size: cover;
              margin-right: 9px;
              vertical-align: middle;
            }
          }
        }
        &.process-container {
          padding: 0 30px;
          display: block;
          overflow: hidden;
          margin-bottom: -55px;
          .process-title {
            font-size: 36px;
            height: 103px;
            font-weight: 500;
            border-bottom: 1Px solid #f0f0f0;
            width: 100%;
            display: flex;
            align-items: center;
          }
          .process-img {
            display: block;
            width: 682px;
            height: 132px;
            background: url('../assets/image/buy-process.png') 0 0 / 100% 100% no-repeat;
            margin: 0 auto;
            margin-top: 79px;
            margin-bottom: 122px;
          }
        }
        .product-info-content{
          @extend %flex-center-row;
          padding-bottom: 28px;
        }
        &.no{
          .product-info-content{
            border-bottom: 1PX solid #eeeeee;
          }
        }
        .jump-detail{
          font-size: 36px;
          color: #888888;
          height: 118px;
          @extend %flex-center;
          .icon{
            width: 13px;
            height: 24px;
            background: url("../assets/image/j2.png") no-repeat center;
            background-size: 13px 24px;
            flex: 0 0 auto;
            margin-left: 28px;
          }
        }
      }

      .coupon-content {
        @extend %content;
        @extend %flex-between-center;
        padding: 40px 31px 40px 29px;
        .coupon-tip-box {
          @extend %flex-row;
          flex: 0 0 auto;

          .txt {
            font-size: 45px;
            color: #222222;
          }

          .coupon-text {
            @extend %flex-center-center;
            font-size: 33px;
            color: #fff;
            background-color: #ff3434;
            border-radius: 10px;
            text-align: center;
            margin-left: 21px;
            padding: 2px 14px;
          }
        }

        .flex {
          display: flex;
          justify-content: space-between;
        }

        .content-text {
          color: #010101;
          font-size: 36px;
          margin-left: 21px;
        }

        .icon {
          width: 24px;
          height: 44px;
          background: url("../assets/image/icon-j.png") no-repeat center;
          background-size: cover;
          flex: 0 0 auto;
          margin-left: 24px;
          display: block;
          flex: 0 0 auto;
        }
      }

      .fix-content {
        @extend %fix-content;
        background-color: #fff;
        padding: 40px 0 20px;

        .price {
          margin-bottom: 36px;

          .txt {
            color: #222222;
            font-size: 36px;
          }

          .num {
            font-size: 48px;
            color: #ff0000;
          }
        }
        &.buyProcessShow {
          display: flex;
          flex-direction: initial;
          justify-content: space-between;
          padding-left: 39px;
          padding-right: 36px;
          .price {
            font-weight: bold;
          }
          .save {
            display: none;
          }
          >>>.center {
            width: initial;
            .btn {
              width: 340px;
              height: 115px;
              font-weight: bold;
              font-size: 42px;
            }
          }
        }
      }

      .pay-content {
        @extend %content;
      }
    }


    .plus-img {
      @extend %content;
      background: transparent;

      img {
        width: 100%;
      }
    }
    .open-storehouse-card {
      @extend %dialog-content;
      padding: 20px 0 109px;
      .header-close-box{
        display: flex;
        justify-content: flex-end;
        .icon{
          background: url("../assets/image/close2.png") no-repeat;
          background-size: 39px;
          background-position: center;
          width: 100px;
          height: 100px;
          display: flex;
          text-align: right;
          z-index: 2;
        }
      }
      .desc {
        font-family: PingFang-SC-Medium;
        font-size: 42px;
        color: #000000;
        padding-top: 50px;
        &.last{
          padding-top: 10px;
        }
      }
      .btn-row {
        position: relative;
        width: 667px;
        margin: 130px auto 0;
        .tip {
          width: 187px;
          height: 54px;
          background-color: #ff2d08;
          border-radius: 28px 27px 27px 0px;
          font-family: SourceHanSansCN-Regular;
          font-size: 33px;
          color: #ffffff;
          position: absolute;
          top: -40px;
          left: 333px;
        }
        .btn {
          width: 667px;
          height: 108px;
          background-image: linear-gradient(-90deg, 
            #ffcf13 0%, 
            #fde104 100%), 
          linear-gradient(
            #008aff, 
            #008aff);
          background-blend-mode: normal, 
            normal;
          border-radius: 54px;
          font-family: PingFang-SC-Bold;
          font-size: 45px;
          color: #000000;
        }
      }
    }
    .tip-app-installed {
      @extend %dialog-content;
      width: 820px;
      padding: 0px 0 109px;
      .header-close-box{
        display: flex;
        justify-content: flex-end;
        .icon{
          background: url("../assets/image/close2.png") no-repeat;
          background-size: 39px;
          background-position: center bottom;
          width: 100px;
          height: 63px;
          display: flex;
          text-align: right;
          z-index: 2;
        }
      }
      .ttl {
        font-family: PingFang-SC-Bold;
        font-size: 45px;
        color: #222222;
      }
      .desc {
        font-family: PingFang-SC-Medium;
        font-size: 36px;
        color: #888888;
        padding: 50px 83px 0;
        text-align: left;
      }
    }
  }
</style>
